import { Lines, FadeUp, DrawLine } from "../site/Reveal";
import { Btn, SectionLabel } from "../site/Btn";
import { useLang } from "../../i18n/lang";
import { useSiteImages } from "../../lib/siteImages";

export const ProcessStrip = () => {
  const { t, to } = useLang();
  return (
    <section className="bg-[#1A1A1A] text-[#FFFFFF] px-6 sm:px-10 lg:px-14 py-28 sm:py-36 lg:py-44 relative" data-testid="process-section">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-20 lg:mb-28">
        <div>
          <SectionLabel n={5} light>{t.processHome.label}</SectionLabel>
          <Lines lines={[t.processHome.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-7xl mt-10" />
        </div>
        <Btn to={to("/process")} variant="ghostLight" testid="process-read-more">{t.processHome.cta}</Btn>
      </div>
      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
        {t.processHome.steps.map(([title, text], i) => (
          <li key={title} data-testid={`process-step-${i + 1}`}>
            <DrawLine dark delay={i * 0.15} />
            <FadeUp delay={0.15 + i * 0.15}>
              <p className="f-serif font-light text-7xl lg:text-8xl text-[#BDBDBD]/80 mt-8 leading-none">0{i + 1}</p>
              <h3 className="f-serif text-3xl font-light mt-8">{title}</h3>
              <p className="mt-4 text-[#D4D4D4] leading-relaxed max-w-xs">{text}</p>
            </FadeUp>
          </li>
        ))}
      </ol>
    </section>
  );
};

export const Closing = () => {
  const { t, to } = useLang();
  const img = useSiteImages();
  return (
    <section className="relative min-h-[90svh] overflow-hidden bg-[#121212] text-[#FFFFFF] flex items-center" data-testid="closing-section">
      <FadeUp y={0} className="absolute inset-0">
        {img("closing") && <img src={img("closing")} alt="Natural stone detail in raking light" loading="lazy" className="w-full h-full object-cover opacity-70" />}
      </FadeUp>
      <div className="absolute inset-0 bg-gradient-to-r from-[#121212]/85 via-[#121212]/40 to-transparent" />
      <div className="relative px-6 sm:px-10 lg:px-14 py-28 max-w-4xl">
        <Lines lines={[t.closing.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-8xl" />
        <FadeUp delay={0.2}>
          <p className="mt-10 text-lg text-[#EBEBEB] max-w-md leading-relaxed">{t.closing.text}</p>
          <div className="mt-10"><Btn to={to("/start-a-project")} variant="light" testid="closing-start-commission">{t.closing.cta}</Btn></div>
        </FadeUp>
      </div>
    </section>
  );
};
